// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__vy4cP","nav":"Navbar_nav__YvXTB"};